<div class="relative flex flex-auto flex-col divide-y overflow-y-auto transition-opacity">
  <slot />
</div>
